import React, {useState} from "react"
import {BsInfoCircle} from "react-icons/bs"
import {IoClose} from "react-icons/io5"
import LanguageSelector from "./LanguageSelector/LanguageSelector"

export default function AllHeader() {
  const currentLanguage = localStorage.getItem("language") || "EN"

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen)
  }

  const closeDrawer = () => {
    setIsDrawerOpen(false)
  }
  return (
    <>
      <div
        style={{
          height: "5.9vh",
          backgroundColor: "#007348",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "fixed",
          width: "100%",
          zIndex: 100,
        }}
      >
        <BsInfoCircle
          size={24}
          style={{
            color: "white",
            marginLeft: "1.7vw",
            cursor: "pointer",
          }}
          onClick={toggleDrawer}
        />
        <LanguageSelector />
      </div>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: isDrawerOpen ? 0 : "-100%",
          height: "100%",
          width: "100%",
          backgroundColor: isDrawerOpen ? "rgba(0, 0, 0, 0.5)" : "transparent",
          zIndex: 999,
          transition: "background-color 0.5s ease, left 0.5s ease",
          pointerEvents: isDrawerOpen ? "auto" : "none",
        }}
        onClick={closeDrawer}
      >
        {/* Drawer Component */}
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "fixed",
            top: 0,
            left: isDrawerOpen ? "0" : "-500px",
            height: "100%",
            width: "300px",
            backgroundColor: "#fff",
            boxShadow: "2px 0px 5px rgba(0,0,0,0.5)",
            transition: "left 0.5s ease",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          {/* Close Drawer Icon */}
          <IoClose
            size={24}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
            }}
            onClick={closeDrawer}
          />

          <h2>
            {currentLanguage === "EN"
              ? "About Us"
              : currentLanguage === "RU"
              ? "О нас"
              : "Hakkımızda"}
          </h2>
          <p>
            {currentLanguage === "EN"
              ? "One of the oldest places in Kyrenia, located in Kyrenia Harbour."
              : currentLanguage === "RU"
              ? "Одно из старейших мест в Кирении, расположенное в гавани Кирении."
              : "  Girne Harbour Limanı'nda bulunan Girne'nin en eski mekanlarından biri."}
          </p>
        </div>
      </div>
    </>
  )
}
